import { forwardRef } from 'react';

import { classNames } from '../../../server/utils/classNames';

export type ModalFooterProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalFooter = forwardRef<HTMLDivElement, ModalFooterProps>(({ className, ...props }, ref) => {
	return (
		<footer
			className={classNames('self-end sm:self-start p-6 flex flex-col gap-3 w-full sm:flex-row', className)}
			ref={ref}
			{...props}
		/>
	);
});
